import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DetectionSequencePatternDto, SequenceAction, DetectionSequenceStepDto, ParkingSpaceNoZonesDto } from '../../../../../api/gen';

@Component({
  selector: 'app-zone-detection-pattern',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './zone-detection-pattern.component.html',
  styleUrl: './zone-detection-pattern.component.scss'
})
export class ZoneDetectionPatternComponent {

  @Input() pattern!: DetectionSequencePatternDto;
  @Input() parkingSpace: ParkingSpaceNoZonesDto | null = null;
  @Output() editPattern = new EventEmitter<string>();
  @Output() deletePattern = new EventEmitter<string>();

  showSteps = signal(false);

  get sortedSteps(): DetectionSequenceStepDto[] {
    return [...(this.pattern.steps ?? [])].sort((a, b) => (a.stepOrder ?? 0) - (b.stepOrder ?? 0));
  }

  getActionLabel(action: SequenceAction | undefined): string {
    if (!action) return 'N/A';
    const actionMap: Record<string, string> = {
      'CreateParkingProcess': '🟢 Create Parking',
      'EndParkingProcess': '🔴 End Parking',
      'TransitionZones': '↔️ Transition Zones',
      'LogOnly': '📝 Log Only'
    };
    return actionMap[action] || action;
  }

  isStepRequired(step: DetectionSequenceStepDto): boolean {
    return step.isRequired ?? false;
  }
  getParkingSpaceDisplay(parkingSpaceId: string): string {

    if (this.parkingSpace && this.parkingSpace.id === parkingSpaceId) {
      return `${this.parkingSpace.name}`;
    }
    return `${parkingSpaceId.substring(0, 8)}...`;
  }
  getZoneDisplay(zoneId: string | undefined | null): string {
    if (!zoneId) {
      return 'Outside';
    }
    const zone = this.parkingSpace?.parkingZones?.find(z => z.id === zoneId);
    return zone?.name ?? `${zoneId.substring(0, 8)}...`;
  }

  onEdit(): void {
    if (this.pattern.id) {
      this.editPattern.emit(this.pattern.id);
    }
  }

  onDelete(): void {
    if (this.pattern.id) {
      this.deletePattern.emit(this.pattern.id);
    }
  }
}
